import gql from "graphql-tag";

export const LOGIN = gql`
  mutation($email: String!, $password: String!) {
    login(email: $email, password: $password)
  }
`;
export const REGISTER = gql`
  mutation register($email: String!, $password: String!) {
    register(email: $email, password: $password)
  }
`;

export const END_TAKEOVER = gql`
  mutation($projectId: ID!, $customerId: ID!) {
    endTakeOver(projectId: $projectId, customerId: $customerId) {
      id
      uuid
      isHumanTakingOver
    }
  }
`;

export const START_TAKEOVER = gql`
  mutation($projectId: ID!, $customerId: ID!) {
    startTakeOver(projectId: $projectId, customerId: $customerId) {
      id
      uuid
      isHumanTakingOver
    }
  }
`;

export const TRACK_OPEN_TAKEOVER_CUSTOMER_CHAT = gql`
  mutation($projectId: ID!, $customerId: ID!) {
    trackOpenTakeOverCustomerChat(
      projectId: $projectId
      customerId: $customerId
    ) {
      id
      uuid
      unSeenMessageAfterTakingOver
    }
  }
`;

export const ADD_MESSAGE = gql`
  mutation($projectId: ID!, $customerId: ID!, $data: DataInput) {
    addMessage(projectId: $projectId, customerId: $customerId, data: $data) {
      messageUUID
      data {
        type
        value
      }
      createdAt
      consoleDetail {
        firstname
        lastname
        id
        email
      }
    }
  }
`;

export const RESEND_EMAIL_VERIFICATION = gql`
  mutation {
    resendVerifyEmail
  }
`;

export const VERIFY_EMAIL = gql`
  mutation verifyEmail($token: String!) {
    verifyEmail(token: $token)
  }
`;
export const EDIT_MEMBER = gql`
  mutation($projectId: ID!, $id: ID!, $role: MemberRole!) {
    editMemberRole(id: $id, projectId: $projectId, role: $role) {
      id
      email
      role
    }
  }
`;

export const DELETE_MEMBER = gql`
  mutation($projectId: ID!, $id: ID!) {
    deleteMember(id: $id, projectId: $projectId) {
      id
      projectId
      email
      role
    }
  }
`;

export const ADD_PRODUCT = gql`
  mutation($projectId: ID!, $product: InputProduct!) {
    addProduct(projectId: $projectId, product: $product) {
      id
      name
      brand
      categories {
        id
        category
      }
      properties {
        id
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          id
          value
          key {
            id
            key
          }
        }
        deleted
        selected
        reserved
        inventory
        image {
          src
        }
      }
    }
  }
`;

export const EDIT_PRODUCT = gql`
  mutation($projectId: ID!, $product: InputProduct!) {
    editProduct(projectId: $projectId, product: $product) {
      id
      name
      brand
      categories {
        id
        category
      }
      properties {
        id
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          id
          value
          key {
            id
            key
          }
        }
        deleted
        selected
        reserved
        inventory
        image {
          src
        }
      }
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation($projectId: ID!, $id: ID!) {
    deleteProduct(projectId: $projectId, id: $id) {
      id
      name
      brand
      categories {
        category
      }
      properties {
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          value
          key {
            key
          }
        }
        deleted
        selected
        image {
          src
        }
      }
    }
  }
`;

export const SET_ADMIN = gql`
  mutation($username: String!, $isAdmin: Boolean!) {
    setAdmin(username: $username, isAdmin: $isAdmin) {
      id
      username
      role
    }
  }
`;

export const VERIFY_TOKEN = gql`
  mutation($token: String!) {
    verifyClientToken(token: $token)
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutation.js